export default "__VITE_ASSET__CxXX4o_Q__"